











































import {Vue, Component} from 'vue-property-decorator'
import {namespace} from 'vuex-class'

import PageHeader from '@/components/PageHeader.vue'
import PageFooter from '@/components/PageFooter.vue'

import SignatureModal from './SignatureModal.vue'
import {getAgreementTextArray} from './constants/agreement'

const biz = namespace('biz')
const taxrefund = namespace('taxrefund')

@Component({
  components: {
    PageHeader,
    PageFooter,
    SignatureModal,
  },
})
export default class Agreement extends Vue {
  @biz.State('name') bizName: string | null
  @biz.State('ownerName') ownerName: string | null
  @biz.Action('getBiz') getBiz: () => Promise<any>
  @taxrefund.State('commissionProposal') commissionProposal: number

  isShowSignatureModal = false

  getCommissionRateText() {
    const rate = this.commissionProposal
    return rate ? `${rate * 100}%` : '30%'
  }
  getAgreementTextArray() {
    const signatureName = this.bizName ? `${this.bizName} 대표 ${this.ownerName || ''}` : `회사대표 ${this.ownerName || ''}`
    return getAgreementTextArray(this.getCommissionRateText(), signatureName)
  }
  getFontWeight(index: number, text: string) {
    if(index === 0 || text.includes('**')) {
      return true
    }
    return false
  }
  handleNext() {
    this.isShowSignatureModal = true
  }

  async mounted() {
    await this.getBiz()
  }
}
